export var LOUDOUN_COUNTY_TABLES;
(function (LOUDOUN_COUNTY_TABLES) {
  LOUDOUN_COUNTY_TABLES["CUSTOMERS"] = "Customers";
  LOUDOUN_COUNTY_TABLES["ATTACHMENTS"] = "Attachments";
  LOUDOUN_COUNTY_TABLES["COMMENTS"] = "Comments";
  LOUDOUN_COUNTY_TABLES["REFERENCES"] = "References";
  LOUDOUN_COUNTY_TABLES["CONDUITS"] = "Conduits";
  LOUDOUN_COUNTY_TABLES["FIBERS"] = "Fibers";
  LOUDOUN_COUNTY_TABLES["HANDHOLES"] = "Handholes";
  LOUDOUN_COUNTY_TABLES["BANK_ACCOUNTS"] = "BankAccounts";
  LOUDOUN_COUNTY_TABLES["BANK_TRANSACTIONS"] = "BankTransactions";
  LOUDOUN_COUNTY_TABLES["BUDGET_ITEMS"] = "Budget_items";
  LOUDOUN_COUNTY_TABLES["EXPENSE_METADATA"] = "ExpenseMetadata";
  LOUDOUN_COUNTY_TABLES["TASKS"] = "Tasks";
  LOUDOUN_COUNTY_TABLES["DEVICES"] = "Devices";
  LOUDOUN_COUNTY_TABLES["INVOICES"] = "Invoices";
  LOUDOUN_COUNTY_TABLES["SUBSCRIPTIONS"] = "Subscriptions";
  LOUDOUN_COUNTY_TABLES["TICKETS"] = "Tickets";
  LOUDOUN_COUNTY_TABLES["ASSETS"] = "Assets";
  LOUDOUN_COUNTY_TABLES["ASSET_ASSIGNMENTS"] = "AssetAssignments";
  LOUDOUN_COUNTY_TABLES["SERVICE_PLANS"] = "ServicePlans";
  LOUDOUN_COUNTY_TABLES["PARCELS"] = "Parcels";
  LOUDOUN_COUNTY_TABLES["INVOICE_LINES"] = "InvoiceLines";
  LOUDOUN_COUNTY_TABLES["PAYMENTS"] = "Payments";
  LOUDOUN_COUNTY_TABLES["CUSTOMERBALANCES"] = "CustomerBalances";
})(LOUDOUN_COUNTY_TABLES || (LOUDOUN_COUNTY_TABLES = {}));